import type { Observable } from 'rxjs';
import type { SavePageViewRequest } from '../models/save-page-view-request.interface';
import type { SavePageViewResponse } from '../models/save-page-view-response';

export const ANALYTICS_SERVICE = Symbol('ANALYTICS_SERVICE');
export interface IAnalyticsService {
    savePageView: (body: SavePageViewRequest) => Observable<SavePageViewResponse>;
}
